import {
  GetTagRequest,
  ListNamespacesRequest,
  ListNamespacesResponse,
  ListTagsRequest,
  ListTagsResponse,
  Tag,
  ReportTagStatsRequest,
  ReportTagStatsResponse,
  ListEntityTagsRequest,
  ListEntityTagsResponse,
} from '@weave/schema-gen-ts/dist/apis/api/wetags/v1/api.pb';
import { useInfiniteQuery } from 'react-query';
import { Query } from './Query';
import { getNamespaces, getTag, getTags, getTagStats, listEntityTags } from './api';

export const namespacesListQuery = Query.create<
  ListNamespacesRequest,
  ListNamespacesResponse
>(
  (options) => [
    'ListNamespacesRequest',
    String(options.pageSize ?? 0),
    options.filter ?? '',
  ],
  getNamespaces
);

export const listEntityTagsQuery = Query.create<
  ListEntityTagsRequest,
  ListEntityTagsResponse
>(
  (options) => ['ListEntityTagsRequest', options.namespaceId ?? '', options.tagId ?? ''],
  listEntityTags
);

const getInfiniteListEntityTagsQueryKey = ({
  namespaceId,
  tagId,
  filter,
  pageSize,
}: Pick<ListEntityTagsRequest, 'namespaceId' | 'tagId' | 'filter' | 'pageSize'>) => [
  'ListEntityTagsRequest',
  namespaceId ?? '',
  tagId ?? '',
  'infinite',
  filter ?? '',
  String(pageSize ?? 0),
];

export const useInfiniteListEntityTagsQuery = ({
  namespaceId,
  tagId,
  filter,
  pageSize = 50,
}: Pick<ListEntityTagsRequest, 'namespaceId' | 'tagId' | 'filter'> & {
  pageSize?: number;
}) =>
  useInfiniteQuery(
    getInfiniteListEntityTagsQueryKey({ namespaceId, tagId, filter, pageSize }),
    ({ pageParam = '' }) =>
      listEntityTags({
        namespaceId,
        tagId,
        filter,
        pageSize,
        pageToken: pageParam,
      }),
    {
      enabled: !!namespaceId && !!tagId,
      getNextPageParam: (lastPage) => lastPage.nextPageToken || undefined,
      refetchOnWindowFocus: false,
    }
  );

export const listTagsQuery = Query.create<ListTagsRequest, ListTagsResponse>(
  (options) => ['ListTagsRequest', options.namespaceId ?? ''],
  getTags
);

export const getTagQuery = Query.create<GetTagRequest, Tag>(
  (options) => ['GetTagRequest', options.namespaceId ?? '', options.tagId ?? ''],
  getTag
);

export const getTagStatsQuery = Query.create<
  ReportTagStatsRequest,
  ReportTagStatsResponse
>(
  (options) => ['ReportTagStatsRequest', options.namespaceId ?? '', options.tagId ?? ''],
  getTagStats
);
